const mmTheme = {
  page: "bg-mmPage text-mmText",
  section: "bg-transparent",
  card: "bg-mmSurface text-mmText",
  surface: "bg-mmSurface",
  border: "border-mmBorder",
  borderStrong: "border-mmBorderStrong",
  accentText: "text-mmAccent",
  accentBorder: "border-mmAccent",
  accentBg: "bg-mmAccent",
  accentLine: "bg-mmAccent",
  accentHover: "hover:bg-mmAccentHover",
  accentRing: "focus:ring-mmFocus",
  textPrimary: "text-mmText",
  textSecondary: "text-mmTextMuted",
  textMuted: "text-mmTextMuted",
  heroTitle: "text-white",
  heroSubtitle: "text-white/90",
  heroOverlay: "mm-heroOverlay",
};

export default mmTheme;
